import './style.css';

( async (_window) => {

    const Minta = {
        init: async (params) => {
            // - v6
            const { handleError, buildIframeUrlWithParams, isMobile } = await import("./helpers.js")
            const { modalElement, prepareMintaButton, hideElement, injectFonts } = await import('./dom-handler.js')
            const { apiKey, targetElementId, disableDefaultCss, customData, isWhiteLabel, wixDemo } = params
            /* Validate */
            if (!apiKey) {
                handleError("no 'apiKey' provided")
                return
            }

            let targetElement = document.getElementById(targetElementId)
            if (!targetElement) {
                handleError(`Failed to find element with id - ${targetElementId}`)
                return
            }

            /* This is for clear any event listeners that might still be on this element, like the bug we had with Ecwid */
            const new_element = targetElement.cloneNode(true);
            targetElement.parentNode.replaceChild(new_element, targetElement);

            /* Insert into the DOM */
            if (!disableDefaultCss) {
                injectFonts()
                prepareMintaButton(new_element)
            }
            const body = document.querySelector("body")
            body.appendChild(modalElement)
            const iframeUrl = buildIframeUrlWithParams({ apiKey, isWhiteLabel, wixDemo })

            /* Listen to events */
            new_element.onclick = () => { // todo - add analytics
                modalElement.style.display = 'block'
                if (isMobile) {
                    modalElement.classList.add("__minta-mobile")
                }
                const iframe = modalElement.querySelector('#__minta-iframe')
                const loader = modalElement.querySelector('.__minta-lds-ripple')
                iframe.src = iframeUrl
                iframe.style.opacity = '0'
                iframe.style.display = 'block'

                loader.style.display = 'block'
                setTimeout(() => {
                    iframe.style.opacity = '1'
                    loader.style.display = 'none'
                    /* in case it's white-label mode. pass the customData */
                    if (isWhiteLabel) {
                        iframe.contentWindow.postMessage({ type: "post-white-label-data", data: customData }, "*")
                    }
                }, 2000)
            }

            _window.addEventListener("message", (event) => {
                if (!event.origin) { // the origin validation comes here
                    return
                }

                if (event.data?.type === "close-minta-editor-window") {
                    const iframe = modalElement.querySelector('#__minta-iframe')
                    hideElement(modalElement)
                    hideElement(iframe)
                }
            })
        }
    }

    _window.minta = Minta

})(window)

// Not in use, keep here if will be in use someday (adding the x icon outside the iframe)
// const closeModalBtn = modalElement.querySelector(".__minta-close-button")
// closeModalBtn.addEventListener('click', () => {
//     const iframe = modalElement.querySelector('#__minta-iframe')
//     hideElement(modalElement)
//     hideElement(iframe)
// })